package com.solevo.dist.navigation

import com.solevo.dist.navigation.NavigationConstants.ORDER_ID_PARAM
import com.solevo.dist.navigation.NavigationConstants.PRODUCT_ID_PARAM
import com.solevo.dist.navigation.NavigationConstants.QUOTE_ID_PARAM

/**
 * Created by Ilija Vucetic on 25.9.25..
 * Copyright (c) 2025 Aktiia. All rights reserved.
 */
sealed class Screen(val route: String) {
    object Home : Screen(route = "/")
    object Orders : Screen(route = "/orders")
    object Quotes : Screen(route = "/quotes")
    object Statement : Screen(route = "/statement")
    object Rewards : Screen(route = "/rewards")
    object Settings : Screen(route = "/settings")
    object TermsAndPrivacy : Screen(route = "/terms-and-privacy")
    object Login : Screen(route = "/login")
    object OrderDetailsPage : Screen(route = "/orderdetails/order") {
        fun withId(id: String) = "$route?${ORDER_ID_PARAM}=$id"
    }
    object ProductDetailsPage : Screen(route = "/productdetails/product") {
        fun withId(id: String) = "$route?${PRODUCT_ID_PARAM}=$id"
    }
    object DeliveryNotePage : Screen(route = "/orderdetails/deliverynote")
    object InvoiceDetailsPage : Screen(route = "/orderdetails/invoice")
    object QuoteDetailsPage : Screen(route = "/quotes/details") {
        fun withId(id: String) = "$route?${QUOTE_ID_PARAM}=$id"
    }
    object TransactionDetailsPage : Screen(route = "/statement/transaction") {
        fun withId(id: String) = "$route?${NavigationConstants.TRANSACTION_ID_PARAM}=$id"
    }
}